module.exports = __webpack_public_path__ + "img/regist-method-manual.58f67a06.svg";